import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faComments,
  faClipboardCheck,
  faFileAlt,
  faListCheck,
  faBook,
  faSync,
  faChartLine,
  faStar,
} from "@fortawesome/free-solid-svg-icons";

import AuthContext from "../../../context/AuthContext";
import WidgetWrapper from "./WidgetWrapper";

const actionIcons = {
  Entretiens: faComments,
  SIM: faClipboardCheck,
  Audits: faFileAlt,
  "Plans d'actions": faListCheck,
  "Biblio'tech": faBook,
  "Mises à jour": faSync,
  "Performance globale": faChartLine,
  Satisfaction: faStar,
};

export default class WidgetQuickActions extends Component {
  static contextType = AuthContext;

  getTypeLabel() {
    const t = Number(this.context.type);
    if ([4, 5].includes(t)) return "assistant";
    if ([0, 1, 2].includes(t)) return "expert";
    return "expert-EAD";
  }

  getActions() {
    const typeLabel = this.getTypeLabel();
    const role = Number(this.context.role);

    const allActions = [
      {
        label: "Entretiens",
        link: `/entretien-${typeLabel}`,
        roles: [0, 1, 2, 3, 4],
      },
      {
        label: "SIM",
        link: `/sim1-${typeLabel}`,
        roles: [0, 1, 2, 3, 4],
      },
      {
        label: "Audits",
        link: "/audit-technical",
        roles: [1, 3, 4],
      },
      {
        label: "Plans d'actions",
        link: "/result-plan-actions",
        roles: [1, 3, 4],
      },
      {
        label: "Biblio'tech",
        link: "/library",
        roles: [0, 1, 2, 3, 4],
      },
      {
        label: "Mises à jour",
        link: "/update",
        roles: [0, 1, 2, 3, 4],
      },
      {
        label: "Performance globale",
        link: "/global-performance",
        roles: [1, 3, 4],
      },
      {
        label: "Satisfaction",
        link: "/satisfaction",
        roles: [1, 2, 3, 4],
      },
    ];

    return allActions.filter((a) => a.roles.includes(role));
  }

  render() {
    const actions = this.getActions();

    return (
      <WidgetWrapper
        title="Accès rapides"
        isCustomizing={this.props.isCustomizing}
        dragHandleProps={this.props.dragHandleProps}
        onHide={this.props.onHide}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(120px, 1fr))",
            gap: "10px",
            padding: "10px 0",
          }}
        >
          {actions.map((action, idx) => (
            <div
              key={idx}
              onClick={() => (document.location.href = action.link)}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                padding: "14px 8px",
                borderRadius: "8px",
                backgroundColor: "#f5f7fa",
                cursor: "pointer",
                transition: "all 0.2s",
                border: "1px solid #e8ecf1",
                gap: "8px",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#026fc2";
                e.currentTarget.style.color = "#fff";
                e.currentTarget.style.borderColor = "#026fc2";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#f5f7fa";
                e.currentTarget.style.color = "#1e1f26";
                e.currentTarget.style.borderColor = "#e8ecf1";
              }}
            >
              <FontAwesomeIcon
                icon={actionIcons[action.label] || faFileAlt}
                style={{ fontSize: "18px" }}
              />
              <span style={{ fontSize: "12px", fontWeight: 500, textAlign: "center" }}>
                {action.label}
              </span>
            </div>
          ))}
        </div>
      </WidgetWrapper>
    );
  }
}
